import React from "react";

function Education() {
  return (
    <div className="center">
      <div>
      <div className="left-align">
        <div>
          <h3>Rutgers Full Stack Coding Bootcamp</h3>
          <h5>Graduated 2023</h5>
        </div>
        <ul>
          <li>
            This six month course propelled my understanding of the tech industry, as well as how to code with others.
          </li>
          <li>
            I learned how to learn modern technologies, frameworks, and the languages which run them, including HTML, CSS, and JS. See my listed skills for more details on the various technologies which I've become familiar with.
          </li>
          <li> 
            Most importantly, I think, I learned how to develop with an AGILE mindset. I learned how to plan and execute the development of a web application effectively within a team.
          </li>
        </ul>
      </div>
      <div className="divider" />
      <div className="left-align">
        <div>
          <h3>University of North Carolina Wilmington</h3>
          <h5>Graduated 2014</h5>
        </div>
        <ul>
          <li>
            Learning the multifaceted science of Geology through UNCW was quite the experience. The most important set of skills it reinforced was how to really see what one is looking at; to use the scientific method; not only how to approach a question, but how to form one.
          </li>
          <li>
            My focus during this point in my development was on petrographic studies; how to identify rocks/minerals. This is a skill which matters to the interpretation of formational histories, but doesn't escape the human context— "what does this mean for us?"
          </li>

        </ul>
      </div>
      <div>
          <a
            href="https://docs.google.com/document/d/1Vje3AEc4ljenISyJjLVpy9ByVyoiplgE/edit?usp=sharing&ouid=117525258448058942395&rtpof=true&sd=true"
            target="_blank"
          >
            <h2> View my full resumé here</h2>
          </a>
        </div>

      </div>
    </div>
  );
}
export default Education;
